import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Spin } from 'antd';
import { AuthGuard } from 'components/AuthGuard';
import WebsiteContentLayout from './WebsiteContentLayout';
import WebsiteContentListPage from './list/WebsiteContentListPage';
import WebsiteContentDeletedPage from './deleted/WebsiteContentDeletedPage';
import WebsiteMediaLibraryPage from './media/WebsiteMediaLibraryPage';
import WebsiteContentLogPage from './logs/WebsiteContentLogPage';

/**
 * 编辑页带 TipTap 与 ProseMirror（约 119KB gzip），按路由懒加载，只在打开编辑页时下载，不影响其他页面。
 * 编辑页路径挂在 list 下，二级菜单按前缀匹配保持「内容列表」选中。
 */
const WebsiteContentEditorPage = React.lazy(() => import('./editor/WebsiteContentEditorPage'));

const editorPage = (
    <Suspense fallback={<div className="flex-1 flex items-center justify-center"><Spin /></div>}>
        <WebsiteContentEditorPage />
    </Suspense>
);

const WebsiteContentRoutes: React.FC = () => (
    <Routes>
        <Route path="/" element={<AuthGuard><WebsiteContentLayout /></AuthGuard>}>
            <Route path="list" element={<WebsiteContentListPage />} />
            <Route path="list/new" element={editorPage} />
            <Route path="list/:id/edit" element={editorPage} />
            <Route path="deleted" element={<WebsiteContentDeletedPage />} />
            <Route path="media" element={<WebsiteMediaLibraryPage />} />
            <Route path="logs" element={<WebsiteContentLogPage />} />
        </Route>
    </Routes>
);

export default WebsiteContentRoutes;
